import React from 'react';
import RegularText from 'modules/emergencies/components/ui/texts/RegularText';
import BodyColumn from 'modules/emergencies/components/ui/columns/bodyColumn';
import styled, { css } from 'styled-components';
import Star from 'modules/emergencies/components/ui/icon/star';
import { SETTINGS } from 'modules/emergencies/constants';
import { ReactComponent as FieldArrayRemoveIcon } from 'assets/icons/field-array-remove.svg';
import { FieldArrayButton } from 'modules/emergencies/components/ticketForm/components/FieldArrayButton';
import deleteFilterView from 'modules/emergencies/api/deleteFilterView';
import { mutate } from 'swr';

const CustomRegularText = styled(RegularText)`
  font-size: 14px;
  text-align: left;
  color: var(--grey700);
  display: flex;
  align-items: center;
  gap: 8px;
  ${Star} {
    margin-bottom: 4px;
  }
`;

const CustomFieldArrayButton = styled(FieldArrayButton)`
  transform: scale(1.5);
  ${(props) =>
    !!props.isDisabled &&
    css`
      svg path {
        fill: var(--grey200);
      }
    `}
  ${(props) =>
    !props.isDisabled &&
    css`
      &:hover {
        svg path {
          fill: black;
        }
      }
    `}
`;

export const ActionsColumn = ({ filterView }) => {
  const deleteView = async (filterView) => {
    try {
      await deleteFilterView({ filterView });
      localStorage.removeItem(SETTINGS.FILTERS_LOCAL_STORAGE_KEY);
      mutate('filter-views');
    } catch (e) {}
  };
  return (
    <BodyColumn
      backgroundColor={'#FFFFFF'}
      width={SETTINGS.FILTER_VIEWS_TABLE_COLUMN_SIZES_IN_PX.ACTIONS}
    >
      <CustomRegularText key={filterView.id}>
        <CustomFieldArrayButton
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            if (filterView.id === -1) return;
            deleteView(filterView);
          }}
          isDisabled={filterView.id === -1}
        >
          <FieldArrayRemoveIcon />
        </CustomFieldArrayButton>
      </CustomRegularText>
    </BodyColumn>
  );
};
